export const TRANSLATIONS_EN = {
    breadcrumb:
    { 
        start: {
            name: 'Start',
            url: '/en'
        },
        infrastructure: {
            name: 'Infrastructure',
            url: '/en/infrastructure/about-infrastructure/'
        },
        catalogue: {
            name: 'Catalogue',
            url: '/catalogue'
        },
        search: {
            name: 'Search',
            url: '/catalogue/search/'
        },
        map: {
            name: 'Map',
            url: '/catalogue/map/'
        }        
    },
    home:{
        'catalogue' : 'Catalogue',
        'see_all': 'See all',
        'laboratories' : 'Laboratories',
        'activityCategories': 'Activities',
        'types': 'Types',
    },
    resources: {
        'catalogue' : 'Catalogue',
        'search_result': 'Search results',
        'wynik': 'result',
        'wyniki': 'results',
        'wynikow': 'results',
        'next_page': 'Next page >',
        'previous_page': '< Previous page'
    },
    'filterpanel': {
        'return': 'Back',
        'clear' : 'Clear all filters',
        'show_more': 'Show more',
        'show_less': 'Show less',
    },
    'filtertags': {
        'actcat': 'Activity',
        'lab': 'Laboratory',
        'am': 'Access mode',
        'kw': 'Keywords',
        'q': 'Query',
        'type': 'Type',
    },
    'resource': {
        'resource_type': 'Resource type',
        'resource_accesstype': 'Access type',
        'resource_accessmode': 'Access mode',
        'resource_classification': 'Classification',
        'resource_location': 'Location',
        'resource_location_country': 'Poland, ',
        'laboratory': 'Laboratory',
        'activity': 'Activities',
        'keyword': 'Keywords',
        'standard': 'Standards',
        'domain': 'Scientific domain',
        'targetuser': 'Target users',
        'language': 'Language',
        'related': 'Related resources',
        'access_data': 'Access info',
        'supplier': 'Provider',
        'webpage': 'Webpage',
        'contact': 'Contact',
        'price_list' : 'Service offer',
        'price_list_link' : 'price list',
        'price_list_url' : 'price-list'
     },
     'gallery': {
        'header': 'Gallery'
     },
     'search':{
        'search_in_resources': 'Search resources',
        'all': 'all'
     },
     'map': {
        'name': 'Resource map',
        'show_map': 'Show map'
    }
    
}